import { X } from "@phosphor-icons/react";

type Props = {
	countryName?: string;
	onClose: () => void;
};

const CompletionModal = ({ countryName, onClose }: Props) => {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-6">
			<div className="bg-white rounded-2xl w-full max-w-md p-6 relative flex flex-col items-center text-center">
				<button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
					<X size={20} />
				</button>
				<img
					src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/airplane-success.png"
					alt="Success"
					className="w-32 h-32 mb-4"
				/>
				<h2 className="text-lg font-bold text-gray-900 mb-2">You have successfully completed!</h2>
				<p className="text-sm text-gray-500 mb-6">
					We will verify your documents to get you to{" "}
					<span className="text-[#3730A3] font-bold">{countryName}</span>
				</p>
				<button onClick={onClose} className="w-full py-3 rounded-xl text-white bg-[#3730A3] font-medium">
					Back to form
				</button>
			</div>
		</div>
	);
};

export default CompletionModal;

